<template>
  <div class="flex">
    <nested-menu-tab-button :title="$tc('server', 2)" icon="icon-server" route="admin.servers.servers"></nested-menu-tab-button>
    &nbsp;
    <nested-menu-tab-button :title="$t('databases')" icon="icon-database" route="admin.servers.databases"></nested-menu-tab-button>
    &nbsp;
    <nested-menu-tab-button :title="$tc('node', 2)" icon="icon-server" route="admin.servers.nodes"></nested-menu-tab-button>
  </div>
</template>

<script>
import NestedMenuTabButton from '@/components/navigations/NestedMenuTabButton'

export default {
  name: 'Shared.Servers.TabNav',
  components: {
    NestedMenuTabButton
  }
}
</script>

<style scoped>

</style>
